

(function($) {
    function onElementMutated(p_options) {
      var observer = new MutationObserver(function(mutations) {
        p_options.callback(mutations);
      });
      var observerConfig = {
        attributes: true, 
        childList: true, 
        characterData: false 
      };
      var targetNodes = document.querySelectorAll(p_options.selector);
      targetNodes.forEach(function(node) {
        observer.observe(node, observerConfig);
      });  
    };  
    
    function getCartData() {
      return new Promise(function(resolve, reject) {
        $.getJSON('/cart.js', function(cart) {
          resolve(cart);
        });
      });
    }
    
    var progressBars = [];
    var selectors = {
      containers: {
        shippingProgress: '.shipping-progress',
        shippingProgressBar: '.shipping-progress .bar',
        shippingProgressMessage: '.shipping-progress .message'
      }
    };
    
    var shippingBar = {
      init: function() {
        // Append message and progressbar markup
        $(selectors.containers.shippingProgress).each(function() {
          $(this).html('<span class="message"></span><div class="bar"></div>');
        });
        
        // Initialize progress bar
        $(selectors.containers.shippingProgress).each(function() {
          var $bar = $(this).find('.bar')[0];
          var progressbar = new ProgressBar.Line($bar, shippingProgressBarSettings.progressBarOptions);
          progressBars.push(progressbar);
        });
      },
      update: function() {
        getCartData()
        .then(function(cart) {
          progressBars.forEach(function(progressbar) {
            progressbar.animate((progress < 1) ? progress : 1);
          });
        });
      }
    }
    
    function updateShippingProgress(cart) {
      var progress = cart.total_price / shippingProgressBarSettings.minCartAmount;
    }
    
    $(function() {
      // On document ready, update shipping bar
      shippingBar.init();
      shippingBar.update();
      
      // On Cart updated, update shipping bar
      onElementMutated({
        selector: '.bigcounter',
        callback: shippingBar.update
      });
    });
  
  })(jQuery);

  function toggleBodyOverflow() {
    const cartDrawer = document.querySelector('cart-drawer');
    const body = document.body;

    if (cartDrawer.classList.contains('active')) {
        body.style.overflow = 'hidden';
    } else {
        body.style.overflow = '';
    }
}
// Set item variants in cart drawer to capital case
const observer = new MutationObserver(toggleBodyOverflow);
observer.observe(document.querySelector('cart-drawer'), { attributes: true, attributeFilter: ['class'] });

// Initial check in case the cart drawer is already open on page load
toggleBodyOverflow();
  // Open megamenu elements on hover
const megaMenuElements = document.querySelectorAll('.mega-menu');
megaMenuElements.forEach((element) => {
  element.addEventListener('mouseenter', () => {
    element.setAttribute('open', '');
  });
  element.addEventListener('mouseleave', () => {
    element.removeAttribute('open');
  });
});

// Classlist toggle on hamburger click 
document.addEventListener('DOMContentLoaded', function () {
document.querySelector('.header__icon--summary').addEventListener('click', function() {
  this.classList.toggle('menu-open');
});
});


// Reusable function to capitalize variants
function capitalizeCartVariants() {
  document.querySelectorAll('.cart-item__variant').forEach(function(element) {
    element.textContent = element.textContent
      .toLowerCase()
      .replace(/(^|\s)\S/g, function(letter) {
        return letter.toUpperCase();
      });
  });
}

// Run the function on page load
document.addEventListener("DOMContentLoaded", function() {
  capitalizeCartVariants();
});



document.addEventListener('DOMContentLoaded', function () {
  // Get all footer headers
  var headers = document.querySelectorAll('.footer-block__header');

  headers.forEach(function(header) {
    header.addEventListener('click', function() {
      // Toggle the active class on the parent div
      var parentBlock = header.parentElement;
      parentBlock.classList.toggle('footer-block--active');
    });
  });
});
document.addEventListener("DOMContentLoaded", function() {
  const bodyElement = document.querySelector('body');
  const currentURL = window.location.href;
  if (currentURL.includes("/fr/")) {
      bodyElement.classList.remove('en')
      bodyElement.classList.add('fr')
  } else {
    bodyElement.classList.remove('fr')
    bodyElement.classList.add('en')
  }
  if (currentURL.includes('return-refund-policy')){
      bodyElement.classList.add('return-refund-policy');
  }
  if (currentURL.includes('return-form')){
      bodyElement.classList.add('return-form');
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.href;
const body = document.querySelector('body');

if (currentUrl.includes('contact')) {
  body.classList.add('contact-page');
  
}

if (currentUrl.includes('return-form')) {
  body.classList.add('return-form-page');    
}
if (currentUrl.includes('return-policy')) {
  body.classList.add('return-policy');    
}
if (currentUrl === `https://www.us.kamik.com` || currentUrl === `https://www.us.kamik.com/` || currentUrl ===  `https://us.kamik.com` || currentUrl === `https://us.kamik.com/`) {
  body.classList.add('homepage');
}
if (currentUrl.includes('shipping')) {
  body.classList.add('shipping');    
}
if (currentUrl.includes('accessibility')) {
  body.classList.add('accessibility');    
}
if (currentUrl.includes('careers')) {
  body.classList.add('careers');    
}
if (currentUrl.includes('warranty')) {
  body.classList.add('warranty');    
}
if (currentUrl.includes('faq')) {
  body.classList.add('faq');    
}
  if (currentUrl.includes('collections')) {
  body.classList.add('collection-page');
};
if (currentUrl.includes('return-instructions')) {
  body.classList.add('return-instructions');    
};
    if (currentUrl.includes('/products/')) {
  body.classList.add('product-page');
};
});

window.addEventListener('scroll', function() {
  if (window.scrollY > 100) {
    document.body.classList.add('scrolled');
  } else {
    document.body.classList.remove('scrolled');
  }
});
window.addEventListener('scroll', function() {
  if (window.scrollY > 1) {
    document.body.classList.add('body-scrolled');
  } else {
    document.body.classList.remove('body-scrolled');
  }
});


document.addEventListener('DOMContentLoaded', function () {
  if (window.location.href.includes('contact')) {
    var typeOfDemandDropdown = document.getElementById('type_of_demand');
    var conditionalFields = [
      'image_of_defect',
      'image_of_boots',
      'image_of_receipt',
      'style_name_or_number',
      'order_number',
      'size',
      'color',
      'shipping_address'
    ];
    var conditionalNonRequired = [
      'retailer_name',
      'purchase_date'
    ]

    function toggleFields() {
      var selectedValue = typeOfDemandDropdown.value;
      var shouldShowFields = (selectedValue === 'Defective product' || selectedValue === 'Defective Apparel Product');
      
      // Show or hide each field and toggle 'required' attribute
      conditionalFields.forEach(function (fieldId) {
        var field = document.getElementById(fieldId);
        var formGroup = field.closest('.form-group');
        
        if (shouldShowFields) {
          formGroup.style.display = 'block';
          field.setAttribute('required', 'required');
        } else {
          formGroup.style.display = 'none';
          field.removeAttribute('required');
        }
      });

      conditionalNonRequired.forEach(function (fieldId) {
        var field = document.getElementById(fieldId);
        var formGroup = field.closest('.form-group');
        
        if (shouldShowFields) {
          formGroup.style.display = 'block';
        } else {
          formGroup.style.display = 'none';
        }
      });
    }

    typeOfDemandDropdown.addEventListener('change', toggleFields);
    toggleFields();
  }



  function showDescriptionField() {
    if (window.location.href.includes('return-form')) {
      const returnReason = document.getElementById('return_reason');
      const describeText = document.getElementById('describeText');
      const descriptionText = document.getElementById('description_text');
      returnReason.addEventListener('change', function() {
        const selectedOption = returnReason.options[returnReason.selectedIndex].value;

        if (selectedOption === 'Other (Please describe)' || selectedOption === 'Product differs from Website (Please describe)') {
          describeText.style.display = 'block';
          descriptionText.setAttribute('required', true);
        } else {
          describeText.style.display = 'none';
          descriptionText.removeAttribute('required');
        }
      });
    }
  }

  showDescriptionField();
});

// ENHANCED STOCK CHECKING WITH SOLD-OUT COLOR FUNCTIONALITY
document.addEventListener('DOMContentLoaded', function() {
  const product = window.product;
  if (!product) return;
  
  // Function to check if a color is completely sold out (all sizes unavailable)
  function isColorSoldOut(colorName) {
    const colorVariants = product.variants.filter(variant => variant.option1 === colorName);
    return colorVariants.every(variant => !variant.available);
  }
  
  // Function to apply grey-out effect to variant images
  function applyImageGreyoutEffect(colorName, isSoldOut) {
    // Multiple selector strategies for finding variant images
    const imageSelectors = [
      `.product__media img[data-color="${colorName}"]`,
      `.product-media img[data-variant-color="${colorName}"]`,
      `.product__photo img[data-color="${colorName}"]`,
      `[data-color="${colorName}"] img`,
      `.variant-image[data-color="${colorName}"]`,
      `.product-single__photo img[data-color="${colorName}"]`,
      `.product__media-item[data-media-color="${colorName}"] img`,
      `.product-single__media[data-color="${colorName}"] img`,
      `.product__media-wrapper[data-color="${colorName}"] img`
    ];
    
    imageSelectors.forEach(selector => {
      const images = document.querySelectorAll(selector);
      images.forEach(img => {
        const wrapper = img.closest('.product__media-item, .product__media, .product-single__media, .variant-image-wrapper') || img.parentElement;
        
        if (isSoldOut) {
          img.classList.add('sold-out-image');
          wrapper.classList.add('sold-out-image-wrapper');
        } else {
          img.classList.remove('sold-out-image');
          wrapper.classList.remove('sold-out-image-wrapper');
        }
      });
    });
    
    // Also check color option elements for images
    const colorOptionSelectors = [
      `.product-form__input-color .form-variant-option-wrap[data-value="${colorName}"]`,
      `.product-form__input-couleur .form-variant-option-wrap[data-value="${colorName}"]`
    ];
    
    colorOptionSelectors.forEach(selector => {
      const colorOptions = document.querySelectorAll(selector);
      colorOptions.forEach(option => {
        const optionImages = option.querySelectorAll('img');
        optionImages.forEach(img => {
          if (isSoldOut) {
            img.classList.add('sold-out-image');
            option.classList.add('sold-out-color-option');
          } else {
            img.classList.remove('sold-out-image');
            option.classList.remove('sold-out-color-option');
          }
        });
      });
    });
  }
  
  // Function to check and apply sold-out styling to all colors
  function checkAndApplySoldOutStyling() {
    // Get all unique colors from variants
    const colors = [...new Set(product.variants.map(variant => variant.option1))];
    
    colors.forEach(color => {
      const isSoldOut = isColorSoldOut(color);
      applyImageGreyoutEffect(color, isSoldOut);
      
      // Apply sold-out class to color options - KEEP CLICKABLE
      const colorOptionSelectors = [
        `.product-form__input-color .form-variant-option-wrap[data-value="${color}"]`,
        `.product-form__input-couleur .form-variant-option-wrap[data-value="${color}"]`
      ];
      
      colorOptionSelectors.forEach(selector => {
        const colorOptions = document.querySelectorAll(selector);
        colorOptions.forEach(option => {
          const input = option.querySelector('input');
          if (isSoldOut) {
            option.classList.add('sold-out-color');
            // Keep input enabled for notify me functionality - do not disable
          } else {
            option.classList.remove('sold-out-color');
            // Ensure input is enabled for available colors
            if (input) input.disabled = false;
          }
        });
      });
    });
  }
  
  // Enhanced version of your existing English function
  function checkStockForSelectedColor() {
    const selectedColorInput = document.querySelector('body.en input[name="Color"]:checked');
    if (!selectedColorInput) return;
    
    const selectedColor = selectedColorInput.value;
    product.variants.forEach((variant) => {
      const colorName = variant.option1;
      const sizeName = variant.option2;
      const available = variant.available;
      if (colorName === selectedColor) {
        const sizeElement = document.querySelector(`body.en input[name="Size"][value="${sizeName}"]`);
        if (sizeElement) {
          if (available) {
            sizeElement.closest('div.form-variant-option-wrap').classList.add('in-stock');
            sizeElement.closest('div.form-variant-option-wrap').classList.remove('out-of-stock');
          } else {
            sizeElement.closest('div.form-variant-option-wrap').classList.add('out-of-stock');
            sizeElement.closest('div.form-variant-option-wrap').classList.remove('in-stock');
          }
        }
      }
    });
  }
  
  // Enhanced version of your existing French function
  function checkStockForSelectedCouleur() {
    const selectedColorInput = document.querySelector('body.fr input[name="Couleur"]:checked');
    if (!selectedColorInput) return;
    
    const selectedColor = selectedColorInput.value;
    product.variants.forEach((variant) => {
      const colorName = variant.option1;
      const sizeName = variant.option2;
      const available = variant.available;
      if (colorName === selectedColor) {
        const sizeElement = document.querySelector(`body.fr input[name="Taille"][value="${sizeName}"]`);
        if (sizeElement) {
          if (available) {
            sizeElement.closest('div.form-variant-option-wrap').classList.add('in-stock');
            sizeElement.closest('div.form-variant-option-wrap').classList.remove('out-of-stock');
          } else {
            sizeElement.closest('div.form-variant-option-wrap').classList.add('out-of-stock');
            sizeElement.closest('div.form-variant-option-wrap').classList.remove('in-stock');
          }
        }
      }
    });
  }
  
  // Initialize sold-out styling on page load
  checkAndApplySoldOutStyling();
  
  // Run your existing functions for English
  if (document.body.classList.contains('en')) {
    checkStockForSelectedColor();
    
    // Listen for clicks on color swatches and re-check stock for the newly selected color
    const colorVariants = document.querySelectorAll('body.en input[name="Color"]');
    colorVariants.forEach((colorVariant) => {
      colorVariant.addEventListener('change', function() {
        checkStockForSelectedColor();
      });
    });
  }
  
  // Run your existing functions for French
  if (document.body.classList.contains('fr')) {
    checkStockForSelectedCouleur();
    
    // Listen for changes in the Couleur selection and re-check stock for the newly selected color
    const couleurVariants = document.querySelectorAll('body.fr input[name="Couleur"]');
    couleurVariants.forEach((couleurVariant) => {
      couleurVariant.addEventListener('change', function() {
        checkStockForSelectedCouleur();
      });
    });
  }
});

// Additional function to handle dynamic inventory updates (if needed)
function updateInventoryDisplay() {
  // This can be called when inventory changes via AJAX
  if (window.product) {
    const colors = [...new Set(window.product.variants.map(variant => variant.option1))];
    colors.forEach(color => {
      const isSoldOut = window.product.variants
        .filter(variant => variant.option1 === color)
        .every(variant => !variant.available);
      
      // You would call applyImageGreyoutEffect here if it was in global scope
      // For now, just trigger the main function
      const event = new CustomEvent('inventoryUpdated');
      document.dispatchEvent(event);
    });
  }
}

document.addEventListener('DOMContentLoaded', function(){
  const priceAndPillWrapper = document.querySelector('.product .product__info-wrapper .product__title.product__title-price div.no-js-hidden');
  if (priceAndPillWrapper) {
    const pills = priceAndPillWrapper.querySelector('.product__breadcrumb-tags-list');
    if (pills.children.length > 1) {
      priceAndPillWrapper.classList.add('multiple-pills');
    }
  }
});


document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', (event) => {
        if (event.target.matches('input.mobile-facets__checkbox')) {
            document.body.classList.remove('overflow-hidden-mobile');
        }
    });

    document.addEventListener('touchstart', (event) => {
        if (event.target.matches('input.mobile-facets__checkbox')) {
            document.body.classList.remove('overflow-hidden-mobile');
        }
    });

      const richTextSections = document.querySelectorAll('section:has(div.rich-text)');
    if (richTextSections) {
      richTextSections.forEach((section) => {
        const heading = section.querySelector('h2.rich-text__heading span');
        if (heading && heading.innerHTML.includes('Our Customer Service Availabilities') || heading.innerHTML.includes('Disponibilités de notre Service à la Clientèle')){
          section.classList.add('customer-service-richtext-section')
        }
      })
    }

    const soldOutBlock = document.querySelector('.product-stock span.sold-out');
    const sizeButtons = document.querySelectorAll('.product-form__input input[type=radio]+label');
    
    
    function toggleSoldOutVisibility() {
      const klaviyoButton = document.querySelector('.product-form__buttons a.klaviyo-bis-trigger');
      const isKlaviyoShowing = klaviyoButton && 
        window.getComputedStyle(klaviyoButton).display !== 'none';
      
      if (isKlaviyoShowing && soldOutBlock) {
        soldOutBlock.style.display = 'block';
      } else if (!isKlaviyoShowing && soldOutBlock) {
        soldOutBlock.style.display = 'none';
      }
    }

    setTimeout(toggleSoldOutVisibility, 500);


    sizeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setTimeout(toggleSoldOutVisibility, 0);
      });
    });

    function adjustLogoPosition() {
      const announcementBar = document.querySelector('.shopify-section-group-header-group .announcement-bar');
      const logo = document.querySelector('.header__heading-logo');
    
      if (announcementBar && logo) {
        const barHeight = announcementBar.offsetHeight;
        if (barHeight > 40) {
        logo.style.top = '0px';
        logo.style.maxWidth = '70px';
        }
      }
    }
    
    // Run on load and resize
    window.addEventListener('load', adjustLogoPosition);
    window.addEventListener('resize', adjustLogoPosition);
});



